import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { CalendarContainer, CalendarGrid, GridItemContainer } from './subcomponents';
import getGridItemComponent from '../helpers/get-grid-item-component';
import addOrdinalSuffix from '../../../helpers/add-ordinal-suffix';
import { ENTER_KEY } from '../../../../../const/keyNames';
import { handleKeyDown } from '../helpers/calendar-helpers';
var ComponentName;
(function (ComponentName) {
    ComponentName["NonSelectable"] = "NonSelectable";
    ComponentName["CurrentDueDay"] = "CurrentDueDay";
})(ComponentName || (ComponentName = {}));
const Calendar = ({ currentDueDay, eligibleDueDays, onSelectDay, selectedDay }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [focusedIndex, setFocusedIndex] = useState(0);
    const gridRef = useRef([]);
    const numbers = Array.from({ length: 28 }, (_, index) => index + 1);
    const ineligibleDays = numbers.filter(day => !eligibleDueDays?.map(item => item.eligibleDueDay)?.includes(day) ||
        day === currentDueDay);
    const rowLength = 7;
    const firstEligibleNumber = numbers.find(num => !ineligibleDays.includes(num));
    const handleKeyDownWrapper = (event, index) => {
        handleKeyDown({
            event,
            index,
            row: rowLength,
            numbersLength: numbers.length,
            ineligibleDays,
            setFocusedIndex
        });
    };
    const handleSelect = (index) => setSelectedIndex(index);
    useEffect(() => {
        if (firstEligibleNumber)
            setFocusedIndex(firstEligibleNumber - 1);
    }, [firstEligibleNumber]);
    useEffect(() => {
        gridRef.current[focusedIndex]?.focus();
    }, [focusedIndex]);
    return (_jsx(CalendarContainer, { top: "small", bottom: "base", "data-testid": "calendar", children: _jsx(CalendarGrid, { vertical: "xlarge", id: "calendarList", role: "grid", "aria-label": "calendar grid", children: numbers.map((day, index) => {
                const { GridItem, componentName } = getGridItemComponent({
                    day,
                    currentDueDay,
                    eligibleDueDays,
                    selectedDay
                });
                const date = addOrdinalSuffix(day);
                const currentDueDate = addOrdinalSuffix(currentDueDay);
                const isAriaDisabled = componentName === ComponentName.NonSelectable ||
                    componentName === ComponentName.CurrentDueDay;
                const selectable = componentName === 'Selectable';
                let gridItemAriaLabel = `Choose the ${date} day of every month`;
                if (componentName === 'NonSelectable')
                    gridItemAriaLabel = `The ${date} day of every month is not available`;
                if (componentName === 'CurrentDueDay')
                    gridItemAriaLabel = `The ${currentDueDate} day of every month is the current payment due date`;
                return (_jsx("div", { role: "row", children: _jsx(GridItemContainer, { role: "gridcell", "data-testid": `grid-item-${day}`, tabIndex: index === focusedIndex ? 0 : -1, "aria-current": selectedIndex === index, "aria-disabled": isAriaDisabled, "aria-label": gridItemAriaLabel, "aria-selected": selectable && selectedIndex === index, "aria-rowindex": Math.floor(index / rowLength) + 1, "aria-colindex": (index % rowLength) + 1, ref: el => {
                            gridRef.current[index] = el;
                        }, onClick: () => {
                            if (selectable)
                                handleSelect(index);
                            onSelectDay(day);
                        }, onKeyDown: event => {
                            if (event.key === ENTER_KEY && selectable) {
                                handleSelect(index);
                                onSelectDay(day);
                            }
                            handleKeyDownWrapper(event, index);
                        }, children: _jsx(GridItem, { "data-testid": "grid-item", "data-cy": componentName, children: day }) }) }, day));
            }) }) }));
};
export default Calendar;
